import React, { memo } from "react";

import { Button, Error } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import { ContentCard } from "cerulean";

import styles from "../Form.module.scss";
import TemplatePreview from "../../TemplatePreview";

import { useTemplateSelector } from "./TemplateSelector.container";

function TemplateSelector() {
  const { l10n } = useLocalization();
  const {
    showManageTemplatesUI,
    sortedFedwireTemplateIds,
    selectedTemplateId,
    onSelectTemplate,
    manageTemplates,
    method,
    error,
  } = useTemplateSelector();

  if (method !== "template") {
    return null;
  }

  return (
    <ContentCard kind="bordered" paddingSize="none">
      <div className={styles.manageTemplatesRow}>
        {l10n.getString("heading-wire-template-selector")}
        {sortedFedwireTemplateIds.length && showManageTemplatesUI ? (
          <Button
            label={l10n.getString("button-manage-templates")}
            kind="plain"
            onClick={manageTemplates}
            size="s"
          />
        ) : null}
      </div>

      {sortedFedwireTemplateIds.length > 0 ? (
        <div className={styles.templateListViewport}>
          <div className={styles.templateList}>
            {sortedFedwireTemplateIds.map((templateId) => (
              <TemplatePreview
                key={templateId}
                templateId={templateId}
                onSelect={onSelectTemplate}
                selected={selectedTemplateId === templateId}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className={styles.emptyContainer}>
          <p className={styles.emptyText}>
            {l10n.getString("message-no-templates")}
          </p>
          {showManageTemplatesUI && (
            <Button
              label={l10n.getString("button-setup-template")}
              kind="plain"
              onClick={manageTemplates}
              size="s"
            />
          )}
        </div>
      )}

      <div className={styles.templateListError}>
        <Error error={error || undefined} marginTop="s" />
      </div>
    </ContentCard>
  );
}

export default memo(TemplateSelector);
